var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommunityRepository } from '@amityco/js-sdk';
import useLiveObject from '../../core/hooks/useLiveObject';
import useFile from '../../core/hooks/useFile';
import { useActionEvents } from '../../core/providers/ActionProvider';
import { ANONYMOUS_METADATA } from '../../social/constants';
const useCommunity = (communityId, resolver) => {
    var _a;
    const community = useLiveObject(() => CommunityRepository.communityForId(communityId), [communityId], resolver);
    const actionEvents = useActionEvents();
    // Must call this hook even if there is a custom file URL which will override it.
    // Cannot call hooks conditionally due to the 'rules of hooks'.
    let file = useFile(community.avatarFileId, [community.avatarFileId]);
    if (community.avatarCustomUrl) {
        file = { fileUrl: community.avatarCustomUrl };
    }
    /*
      developer's note: payload is: {
        communityId: string,
        displayName?: string,
        description?: string,
        avatarFileId?: string,
        categories?: string[],
        tags?: string[],
        metadata?: Object,
        isPublic?: boolean,
        postSetting?: boolean,
      }
    */
    const updateCommunity = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        return yield CommunityRepository.updateCommunity(Object.assign({ communityId }, payload));
    });
    const joinCommunity = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        (_b = actionEvents.onCommunityJoin) === null || _b === void 0 ? void 0 : _b.call(actionEvents, { communityId });
        yield CommunityRepository.joinCommunity(communityId);
    });
    const leaveCommunity = () => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        (_c = actionEvents.onCommunityLeave) === null || _c === void 0 ? void 0 : _c.call(actionEvents, { communityId });
        yield CommunityRepository.leaveCommunity(communityId);
    });
    const closeCommunity = () => __awaiter(void 0, void 0, void 0, function* () {
        var _d;
        (_d = actionEvents.onCommunityClose) === null || _d === void 0 ? void 0 : _d.call(actionEvents, { communityId });
        yield CommunityRepository.closeCommunity(communityId);
    });
    const handleCommentingToggle = () => {
        var _a;
        updateCommunity({
            metadata: Object.assign(Object.assign({}, community.metadata), { areCommentsHidden: !community.metadata.isCommentingDisabled, isCommentingDisabled: !community.metadata.isCommentingDisabled }),
        });
        (_a = actionEvents.onCommentsToggled) === null || _a === void 0 ? void 0 : _a.call(actionEvents, {
            target: 'community',
            value: community.metadata.isCommentingDisabled ? 'on' : 'off',
        });
    };
    const handleAnonymousToggle = () => {
        var _a;
        updateCommunity({
            metadata: Object.assign(Object.assign({}, community.metadata), { [ANONYMOUS_METADATA]: !community.metadata[ANONYMOUS_METADATA] }),
        });
        (_a = actionEvents.onAnonymousToggled) === null || _a === void 0 ? void 0 : _a.call(actionEvents, {
            value: community.metadata[ANONYMOUS_METADATA] ? 'on' : 'off',
        });
    };
    return {
        community,
        file,
        communityCategories: (_a = community === null || community === void 0 ? void 0 : community.categories) !== null && _a !== void 0 ? _a : [],
        joinCommunity,
        leaveCommunity,
        updateCommunity,
        closeCommunity,
        handleCommentingToggle,
        handleAnonymousToggle,
    };
};
export default useCommunity;
//# sourceMappingURL=useCommunity.js.map